import { useState, useEffect, useCallback } from "preact/hooks";
import { copyToClipboard } from "../utils/clipboard";
import type { IUseCopyCell } from "../types";

export const useCopyCell = (): IUseCopyCell => {
    const [selectedCell, setSelectedCell] = useState<string | null>(null);
    const [selectedValue, setSelectedValue] = useState<string | null>(null);

    const handleCellClick = useCallback((cellID: string, value: string) => {
        setSelectedCell(cellID);
        setSelectedValue(value);
    }, []);

    const clearSelection = useCallback(() => {
        setSelectedCell(null);
        setSelectedValue(null);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'с') && selectedValue !== null) {
                e.preventDefault();
                copyToClipboard(selectedValue);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedValue]);

    const getCellClass = useCallback((cellId: string) => {
        return selectedCell === cellId
            ? 'bg-primary/20 border-2 border-primary rounded'
            : '';
    }, [selectedCell]);

    return { selectedCell, handleCellClick, getCellClass, clearSelection };
}